import React from 'react'

import { useQuery, gql } from '@apollo/client'
import { Helmet } from 'react-helmet-async'

let ErrorHeader = ({ title }) => (
	<Helmet>
		<title>{title}</title>
	</Helmet>
)

export function PathHead({ uri, type }) {
	const GET_YOAST = gql`
		query GET_YOAST($uri: String!) {
			allSettings {
				title: generalSettingsTitle
			}

			nodeByUri(uri: $uri) {
				... on ${type ?? 'Page'} {
					id
					seo {
						focuskw
						canonical
						title
						metaDesc
						opengraphImage {
							sourceUrl
						}
					}
				}
			}

			notFound: seo {
				meta {
					page: notFound {
						title
					}
				}
			}
		}
	`

	const { data, loading, error } = useQuery(GET_YOAST, { variables: { uri } })

	if (loading) return <></>
	let yoast = data.nodeByUri ? data.nodeByUri.seo : null
	if (!yoast || error)
		return <ErrorHeader title={data.notFound.meta.page.title} />

	return (
		<Helmet>
			<title>{yoast.title}</title>
			{yoast.metaDesc ? (
				<meta name="description" content={yoast.metaDesc} />
			) : (
				<></>
			)}
			{yoast.canonical ? (
				<link rel="canonical" href={yoast.canonical} />
			) : (
				<></>
			)}
			{yoast.focuskw ? (
				<meta name="keywords" content={yoast.focuskw} />
			) : (
				<></>
			)}{' '}
			{yoast.opengraphImage ? (
				<meta
					property="og:image"
					content={yoast.opengraphImage.sourceUrl}
				/>
			) : (
				<></>
			)}
		</Helmet>
	)
}
